/* eslint-disable no-alert, no-console */
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "utils/api-client-wrapper";
import type { DeleteV1UsersMeDestroyMutationResponse } from "../../../types/DeleteV1UsersMeDestroy.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "utils/api-client-wrapper";

function getDeleteV1UsersMeDestroyUrlClient() {
  const res = { method: 'DELETE', url: `/v1/users/me/destroy` as const }
  return res
}

/**
 * @summary Delete current user account
 * {@link /v1/users/me/destroy}
 */
export async function deleteV1UsersMeDestroyClient(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DeleteV1UsersMeDestroyMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getDeleteV1UsersMeDestroyUrlClient().url.toString(), ... requestConfig })
  return res
}